import { AxiosConfig, BaseService } from './BaseService';
import { AxiosPromise } from 'axios';
import { resources } from '../resources';
import { SubmitApplicationInvitation } from '../models/application/SubmitApplicationInvitation';

export class ApplicationInvitationService extends BaseService {
  public async submitApplicationInvitation(request: SubmitApplicationInvitation, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.put<void>(resources.submitApplicationInvitation, request, {}, options);
  }
  public async resendApplicationInvitation(userId: string, options: AxiosConfig = {}): AxiosPromise<void> {
    return this.post<void>(resources.resendApplicationInvitation, {}, { userId: userId }, options);
  }
}
